import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { MonthlyCalendarHeaderRow, MonthlyCalendarRow } from 'components/Calendar'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getCurrentDate } from 'reducks/calendar/selectors'
import { getCalendarArray } from 'lib/calendar'
import { endOfMonth, startOfMonth } from 'date-fns'

type Props = {
  isDeliveryCalendar: boolean
}

const MonthlyCalendar: FC<Props> = (props) => {
  const { isDeliveryCalendar } = props
  const currentDate = useSelector((state: State) => getCurrentDate(state))
  const calendar = getCalendarArray(startOfMonth(currentDate), endOfMonth(currentDate))

  return (
    <table className={styles.table}>
      <thead>
        <MonthlyCalendarHeaderRow />
      </thead>
      <tbody>
        {calendar.map((row, rowNum) => (
          <MonthlyCalendarRow key={rowNum} row={row} isDeliveryCalendar={isDeliveryCalendar} />
        ))}
      </tbody>
    </table>
  )
}

export default MonthlyCalendar
